import React, { useState } from 'react';

interface ImageWithFallbackProps {
  src: string;
  alt: string;
  className?: string;
  style?: React.CSSProperties;
  audioUrl?: string;
  width?: number | string;
  height?: number | string;
  loading?: 'lazy' | 'eager';
}

const PLACEHOLDER = '/images/acetate-placeholder.jpg';

/**
 * Simple image component with fallback to placeholder on error.
 */
const ImageWithFallback: React.FC<ImageWithFallbackProps> = ({
  src,
  alt,
  className,
  style,
  width,
  height,
  loading = 'lazy'
}) => {
  const [hasError, setHasError] = useState(false);

  // Normalize path to start with /
  const normalizedSrc = src && !src.startsWith('/') ? `/${src}` : src;
  const imageSrc = hasError || !normalizedSrc ? PLACEHOLDER : normalizedSrc;

  return (
    <img
      src={imageSrc}
      alt={alt}
      className={className}
      style={style}
      width={width}
      height={height}
      loading={loading}
      onError={() => setHasError(true)}
    />
  );
};

export default ImageWithFallback;